"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = require("redux");

var _reduxThunk = require("redux-thunk");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxBatchedActions = require("redux-batched-actions");

var _reducer = require("../reducers/reducer.server");

var _reducer2 = _interopRequireDefault(_reducer);

var _config = require("../config");

var _config2 = _interopRequireDefault(_config);

var _persistActionsMiddleware = require("../middleware/persist-actions-middleware.server");

var _persistActionsMiddleware2 = _interopRequireDefault(_persistActionsMiddleware);

var _socketLayerMiddleware = require("../middleware/socket-layer-middleware.server");

var _socketLayerMiddleware2 = _interopRequireDefault(_socketLayerMiddleware);

var _remoteRequestMiddleware = require("../middleware/remote-request-middleware.server");

var _remoteRequestMiddleware2 = _interopRequireDefault(_remoteRequestMiddleware);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function configureStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var roomId = arguments[1];
  var messageLayer = arguments[2];
  var token = arguments[3];
  var middlewareList = [(0, _persistActionsMiddleware2.default)(roomId, _config2.default, token), _remoteRequestMiddleware2.default];

  if (messageLayer) {
    middlewareList = middlewareList.concat((0, _socketLayerMiddleware2.default)(messageLayer, roomId));
  }

  middlewareList = middlewareList.concat(_reduxThunk2.default);
  return (0, _redux.createStore)((0, _reduxBatchedActions.enableBatching)(_reducer2.default), initialState, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, _toConsumableArray(middlewareList))));
}